import { useEffect, useState } from 'react';

const useWindowWidth = (): number => {
  // need replace by useClientSize
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);
  return width;
};

export default useWindowWidth;
